import { ROW_SCHEMA_VERSION_V1 } from '../db.js';
export function toTraceRow(trace) {
    return {
        id: trace.id,
        name: trace.name,
        createdAt: trace.createdAt,
        ...(trace.driverKind !== undefined ? { driverKind: trace.driverKind } : {}),
        frameJson: JSON.stringify(trace.frame),
        tags: trace.tags ? [...trace.tags] : [],
        schemaVersion: ROW_SCHEMA_VERSION_V1,
    };
}
export function fromTraceRow(row) {
    const frameRaw = JSON.parse(row.frameJson);
    const frame = Object.freeze({
        sequence: frameRaw.sequence,
        timestamp: frameRaw.timestamp,
        frequencies: Object.freeze([...frameRaw.frequencies]),
        s11: Object.freeze([...frameRaw.s11]),
        ...(frameRaw.s21 ? { s21: Object.freeze([...frameRaw.s21]) } : {}),
    });
    return {
        id: row.id,
        name: row.name,
        createdAt: row.createdAt,
        ...(row.driverKind !== undefined ? { driverKind: row.driverKind } : {}),
        frame,
        ...(row.tags.length > 0 ? { tags: Object.freeze([...row.tags]) } : {}),
    };
}
//# sourceMappingURL=trace-row.js.map